import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff, ExternalLink, AlertTriangle } from 'lucide-react';

const DomainHealthCheck = ({ children }) => {
  const [isDomainHealthy, setIsDomainHealthy] = useState(true);
  const [isChecking, setIsChecking] = useState(false);
  const [lastCheck, setLastCheck] = useState(null);

  const checkDomainHealth = async () => {
    setIsChecking(true);
    try {
      // Check if we're on the custom domain
      const isCustomDomain = window.location.hostname === 'sabiwabee.com';
      
      if (isCustomDomain) {
        // Try to fetch a simple resource to check connectivity
        // Use the Railway URL directly since the custom domain might not work
        const response = await fetch('https://sabiwabeeai-production.up.railway.app/api/health', {
          method: 'GET',
          timeout: 5000,
        });
        
        if (!response.ok) {
          throw new Error('Domain health check failed');
        }
        
        setIsDomainHealthy(true);
        setLastCheck(new Date());
      } else {
        // Not on custom domain, assume healthy
        setIsDomainHealthy(true);
        setLastCheck(new Date());
      }
    } catch (error) {
      console.warn('🔴 Domain health check failed:', error);
      setIsDomainHealthy(false);
      setLastCheck(new Date());
    } finally {
      setIsChecking(false);
    }
  };

  useEffect(() => {
    // Temporarily disable domain health checks to prevent interference
    // checkDomainHealth();
    
    // Set up periodic health checks (every 30 seconds)
    // const interval = setInterval(checkDomainHealth, 30000);
    
    // return () => clearInterval(interval);
  }, []);

  // Temporarily disable domain health checks - just render children
  return children;
};

export default DomainHealthCheck;
